<style>
@import '../blog/BlogSingle.css';
</style>

<template>
  <div class="blog-single" v-if="!checkIsEmpty(dica)">
    <div class="container">

      <!-- Breadcrumb -->
      <section class="row p-25">
        <div class="col-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link class="text-uppercase" :to="{ name: 'home' }"
                  >Início</router-link
                >
              </li>
              <li class="breadcrumb-item">
                <router-link class="text-uppercase" :to="{ name: 'blog-geral' }"
                  >Blog</router-link
                >
              </li>
              <li class="breadcrumb-item active text-uppercase">
                {{ dica[0].titulo }}
              </li>
            </ol>
          </nav>
        </div>
      </section>

      <!-- Container of page -->
      <section class="row">

        <!-- Title of page -->
        <div class="col-12 mb-4">
          <h1 class="h1-after text-uppercase fwb mb-4">BLOG</h1>
        </div>

        <!--Container of text BLog-->
        <section class="col-md-8 mb-md-0 mb-5">

          <!--Title-->
          <div class="border-bottom py-2" v-if="dica[0].titulo !== null">
            <h2>{{ dica[0].titulo }}</h2>
          </div>
          <!-- <div
            class="inter-n p-2 mb-4"
            v-if="dica[0].texto_1 !== null" v-html="dica[0].texto_1"
          ></div> -->
          
          <!--Image-->
          <div
            class="box-img mb-4 shadow h-auto"
            v-if="dica[0].imagem !== null"
          >
            <img
              :src="`${getImagesAddress}${dica[0].imagem}`"
              alt="Imagem da dica"
            />
          </div>

          <!--Video-->
          <div v-if="dica[0].video !== null">
            <div>
              <iframe
                class="w-100"
                height="400"
                :src="'//www.youtube.com/embed/' + getId(dica[0].video)"
                frameborder="0"
                allowfullscreen
              ></iframe>
            </div>
            <div class="w-100">
              <a
                class="btn bg-orange c-white text-uppercase mb-4"
                :href="dica[0].video"
                target="_blank"
                >Assista o Vídeo no Youtube</a
              >
            </div>
          </div>

          <!--Text Blog-->
          <p
            class="inter-n text-justify mb-4"
            v-if="dica[0].texto_2 !== null"
            v-html="dica[0].texto_2"
          ></p>
          
          <!--Share social media-->
          <section class="list-with-text-share">
            <div>
              <p class="inter-b mb-2">Compartilhe:</p>
            </div>
            <ul class="list-share-social">
              <li>
                  <ShareFacebook class="inter-b mb-2 mr-2"
                  :title="this.dica[0].titulo"
                  :text="this.dica[0].texto_1"
                  />
              </li>
              <li>
                <ShareLinkedIn class="inter-b mb-2 mr-2"
                :title="this.dica[0].titulo"
                :text="this.dica[0].texto_1"
                />
              </li>
              <li>
                <ShareCopyLink class="inter-b mb-2 mr-2"
                :title="this.dica[0].titulo"
                :text="this.dica[0].texto_1"
                />
              </li>
            </ul>
          </section>
        </section>

        <!--Panel others subjects-->
        <section class="col-md-4" v-if="dicas.length > 0">
          <!--Title -->
            <div class="text-center p-2">
              <h3 class="h1-after-center text-uppercase font-weight-bold mb-4">
                Outros Assuntos
              </h3>
            </div>

          <!--List of Cards -->
          <aside class="box-aside bg-white-1">
            <ul class="list-of-cards">
              <li
                class="layout-cards p-2"
                v-for="(dicaSpec, index) in dicas"
                :key="index"
              > 

                <!--Cards-->
                <router-link
                  class="text-dark text-decoration-none"
                  :to="{ name: 'blog-single', params: { id: dicaSpec.id } }"
                > 
                  <div class="text-bg-primary mb-3">
                      <div class="card-body">
                        <!--Title of Cards-->
                        <h6 class="card-title">{{ dicaSpec.titulo }}</h6>
                        <!--Text of Cards-->
                        <p
                          class="card-text text-justify"
                          v-html="dicaSpec.texto_1">
                        </p>
                      </div>
                  </div>
                  
                </router-link>
              </li>
            </ul>
          </aside>

        </section>

      </section>        
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ShareLinkedIn from '../../components/SocialShares/ShareLinkedIn.vue';
import ShareFacebook from '../../components/SocialShares/ShareFacebook.vue';
import ShareCopyLink from '../../components/SocialShares/ShareCopyLink.vue';

export default {
  name: 'blog-single',
  components: {
    ShareLinkedIn,
    ShareFacebook,
    ShareCopyLink,
  },

  props: ['id'],
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      dica: (state) => state.dica,
      dicas: (state) => state.dicas,
    }),
  },

  watch: {
    '$route.params.id': function (id) {
      this.carregarPagina();
      this.urlSite = window.location.href;
    },
  },
  created() {
    this.carregarPagina();
  },
  activated() {
    this.carregarPagina();
  },

  methods: {
    carregarPagina() {
      this.$store.dispatch('showDica', this.id);
      this.$store.dispatch('showDicasRelacionadas', this.id);
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    getId(url) {
      const regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      const match = url.match(regExp);
      if (match && match[2].length === 11) {
        return match[2];
      }
      return 'error';
    },
  },
};
</script>
